module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"imported":"Импортирован","invited":"Приглашение отправлено","interviewed":"Прошел интервью","inoffice_interview":"Приглашен на очное интервью","job_offer":"Предложение о работе","hired":"Выход на работу","declined":"Отказ"}}')
  delete Component.options._Ctor
}
